module.exports = __webpack_public_path__ + "img/home-53-hero_16x9_cn_poster.88f0804.jpg";